import { defineComponent as _defineComponent } from 'vue'
import GuideItem from '@/features/editorial/components/GuideItem.vue';
import { GuideEntryFragment } from '@/features/editorial/graphql/queries/GetGuideArticles.query';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'GuideFeatured',
  props: {
    items: null
  },
  setup(__props: any) {

const props = __props as { items: GuideEntryFragment[] };



const featuredItem = computed(() => props.items[0] ?? null);
const otherItems = computed(() => props.items.slice(1));

return { __sfc: true,props, featuredItem, otherItems, GuideItem }
}

})